import React from 'react';

import { StarGray } from '@travel/icons/ui';
import { StarRatingText } from '@travel/ui';
import { cx } from '@travel/utils';

import styles from './providerReviewSkeleton.module.scss';

const stars = Array.from({ length: 5 }, (_, i) => (
  <StarGray key={i} className={styles.loadingStar} size={16} />
));

const filterSection = (
  <div className={styles.filterSectionContainer}>
    <div className={styles.filterSection}>
      {[...Array(3)].map((_, i) => (
        <div key={i}></div>
      ))}
    </div>
    <div className={styles.popularTopics}>
      {[...Array(6)].map((_, i) => (
        <div key={i}></div>
      ))}
    </div>
  </div>
);

const mediaSection = (
  <div className={styles.mediaSection}>
    {[...Array(5)].map((_, i) => (
      <div key={i}></div>
    ))}
  </div>
);

const userReviewSection = (
  <div className={styles.userReviewSection}>
    <div>
      <div className={cx(styles.starContainer, styles.disableLineInSp)}>{stars}</div>
      <div className={cx(styles.starRowTwo, styles.disableLineInSp)}></div>
      <div className={styles.hotelInfoRow}>
        <div className={cx(styles.hotelPicture, styles.contentSection)}></div>
        <div className={styles.hotelTitle}>
          <div className={cx(styles.rowOne, styles.contentSection)}></div>
          <div className={cx(styles.rowTwo, styles.contentSection)}></div>
        </div>
      </div>
    </div>
    <div className={styles.reviewInfo}>
      <div className={cx(styles.starContainer, styles.hideLineInPc)}>
        {stars}
        <div className={cx(styles.starRow, styles.contentSection)}></div>
      </div>
      <div className={cx(styles.starRowTwo, styles.hideLineInPc)}></div>
      <div className={styles.reviewPicSection}>
        {[...Array(4)].map((_, index) => (
          <div key={index} className={cx(styles.pics, styles.contentSection)}></div>
        ))}
        <div className={styles.picsContainerSP}>
          {[...Array(2)].map((_, groupIndex) => (
            <div key={groupIndex} className={styles.group}>
              <div className={cx(styles.largeBox, styles.contentSection)}></div>
              <div className={styles.smallBoxes}>
                {[...Array(2)].map((_, boxIndex) => (
                  <div key={boxIndex} className={cx(styles.smallBox, styles.contentSection)}></div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.reviewTextSection}>
        {[...Array(6)].map((_, index) => (
          <div
            key={index}
            className={cx(
              styles[`row${index + 2}`],
              styles.contentSection,
              styles.borderRadiusFull,
            )}
          ></div>
        ))}
      </div>
      <div className={cx(styles.row8, styles.contentSection)}></div>
      <div className={cx(styles.row9, styles.contentSection, styles.disableLineInSp)}></div>
    </div>
  </div>
);

const scoreSection = (
  <div className={styles.skeletonWrapper}>
    <div className={styles.skeletonFirstSection}>
      <div className={styles.skeletonOverallScoreSection}>
        <div className={styles.skeletonTitle}></div>
        <StarRatingText
          displayGrayStar={true}
          className={styles.starRating}
          iconSize={16}
          isDisplayRating={false}
        />
        <div className={styles.skeletonReviewCount}></div>
      </div>
      <div className={styles.skeletonScoreDistributionSection}>
        {[...Array(5)].map((_, index) => (
          <div key={index} className={styles.skeletonRatingRow}>
            <StarGray className={styles.starIcon} size={14} />
            <div className={styles.skeletonBar}></div>
          </div>
        ))}
      </div>
      <div className={styles.skeletonCategoryScore}>
        {[...Array(6)].map((_, index) => (
          <div key={index} className={styles.gridItem}>
            {index === 0 && <div className={styles.divider} />}
            <div className={styles.skeletonCategoryBox}></div>
            <div className={styles.divider}></div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

const topSkeleton = (
  <>
    <div className={styles.title}></div>
    {scoreSection}
    <div className={styles.aiSection}></div>
    <div className={cx(styles.horizontalLine, styles.disableLineInSp)}></div>
    {filterSection}
    <div className={cx(styles.horizontalLine, styles.hideLineInPc)}></div>
    <div className={styles.title}></div>
    {mediaSection}
    <div className={cx(styles.sectionHorizontalLine, styles.hideLineInPc)}></div>
    <div className={cx(styles.horizontalLine, styles.disableLineInSp)}></div>
  </>
);

export const ReviewListSkeleton = () => (
  <>
    {userReviewSection}
    <div className={cx(styles.sectionHorizontalLine, styles.hideLineInPc)}></div>
    <div className={cx(styles.horizontalLine, styles.disableLineInSp)}></div>
    {userReviewSection}
  </>
);

const ProviderReviewSkeleton = () => {
  return (
    <div className={styles.reviewLoaderContainer}>
      {topSkeleton}
      <ReviewListSkeleton />
    </div>
  );
};

export default ProviderReviewSkeleton;
